var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"guide\">\n    <div class=\"guideImage\">\n        <div class=\"guideText\">\n            <img src=\"" + require("../images/pos/guidelogo.png") + "\" class=\"guidelogo hidden\">\n        </div>\n        <div class=\"guideBtn\">\n        </div>\n    </div>\n    <div class=\"guideModal\">\n        <div class=\"guide-survey\">\n            <div class=\"guide-body\">\n            </div>\n            <div class=\"guide-foot\">\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/GuideView.handlebars
// module id = 636
// module chunks = 0